import Lara from '@primeuix/themes/lara';
import { definePreset } from '@primeuix/themes';

/**
 * AmSuite PrimeNG 21 theme preset.
 *
 * Sostituisce il vecchio tema CSS statico (src/assets/primeng/am-suite-theme.css)
 * eliminato durante la migrazione a PrimeNG 21 + @primeuix/themes.
 *
 * Brand: ARANCIONE AmSuite. La tinta `primary.500` DEVE rimanere `#f19124`
 * (lo stesso valore usato dagli altri frontend del monorepo gia` migrati:
 * comunica, manage-users, crm, party-profiler, attendance-sheet).
 *
 * NOTA: il "redesign layer" (src/assets/redesign/*.css, con il proprio set di
 * variabili --orange-* / --accent) e` un layer separato caricato DOPO in
 * angular.json e NON dipende da questo preset. Questo preset definisce solo i
 * design token interni dei componenti PrimeNG.
 */
export const AmSuitePreset = definePreset(Lara, {
  semantic: {
    // PrimeNG 22 ha legato columnTitle, bodyCell e columnFooter della
    // tabella a {typography.font.size}; in v21 non lo dichiaravano ed
    // ereditavano il body. Il default del tema base e' 0.875rem, che
    // rimpicciolisce le tabelle dentro pagine che scrivono a 1rem.
    typography: {
      fontSize: "1rem",
    },
    primary: {
      50: '#fef3e7',
      100: '#fcdcc0',
      200: '#f9c195',
      300: '#f5a567',
      400: '#f29344',
      500: '#f19124',
      600: '#e07b1e',
      700: '#bd6118',
      800: '#964c13',
      900: '#6e370e',
      950: '#3d1e07'
    },
    colorScheme: {
      light: {
        primary: {
          color: '{primary.500}',
          contrastColor: '#ffffff',
          hoverColor: '{primary.600}',
          activeColor: '{primary.700}'
        }
      }
    }
  },
  components: {
    // Lara v22 fissa il tooltip a 0.625rem; in v21 non dichiarava fontSize
    // ed ereditava il body. Si rimette la misura di prima, come gia fanno
    // le altre app nel proprio blocco tooltip.
    tooltip: {
      root: {
        fontSize: "1rem",
      },
    },
  },
} as any);
